import Styled from 'styled-components'

export const ReceivedQuestionHeader = Styled.div`
min-width:400px ;
margin:20px 0px;
border-radius:5px ; 
padding:15px 20px ; 
overflow:hidden ; 
border:1px solid #c2c2c2; 
`

export const ReceivedQuestionTitle = Styled.div`
   width:100%;
   padding:5px 5px;  
   font-family:Sans-serif;

`
export const QuestionTitle = Styled.div`
    float:left;
`
export const QuestionIcon = Styled.div`
    float:right; 
`
export const ReceivedQuestionBody = Styled.div`
    width:100% ; 
    margin:5px 0px ;
    padding:5px 5px ; 
    overflow:hidden;
`
